export default {
    'diagram3b1-6': {
        'checkboxes': {
            'title': 'Question:	',
            'checkbox-1': 'Why?',
            'checkbox-2': 'How?',
            'checkbox-3': 'How do you know?',
        },
        'elements': {
            'one': 'Those who recognized Chaos in the early days agonized how to shape their thoughts and findings into publishable form',
            'two': 'The work fell between disciplines – too abstract for physicists, too experimental for mathematicians',
            'three': 'The insights behind fractals and unpredictability were very difficult to explain clearly',
            'four': 'The resistance from those required to reorganize their picture of the world was ferocious'
        },
        'checkboxes-bottom': {
            'title': 'General Plural Noun',
            'checkbox-1': 'Reasons',
            'checkbox-2': 'Steps',
            'checkbox-3': 'Proofs',
        },
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b1/diagram6/i18n/en.js